// @flow
import * as React from 'react';
import { RequiredActionProps } from '../../types';
import { Box, ButtonBase, Stack, Typography } from '@mui/material';
import moment from 'moment/moment';
import { XIcon } from '@phosphor-icons/react';
import {
  Portal, useAppointmentReminderCreatedNewAppointmentWithAnotherAgentConfirmByAgentMutation, UserAvatar
} from '../../../../shared';
import { useMemo } from 'react';
import { LoadingButton } from '@mui/lab';


export const ArAgentReassignedRequiredAction = ({item, onResolved, onHide}: RequiredActionProps) => {
  const details = useMemo(() => JSON.parse(item.detailsJson), [item.detailsJson]);
  const [done] = useAppointmentReminderCreatedNewAppointmentWithAnotherAgentConfirmByAgentMutation({
    variables: {id: item.id},
  })

  const complete = async () => {
    await done();
    onResolved();
  }

  return (
    <Portal sx={{'&:hover': {border: '1px solid #d0d5e1' }, transition: 'all .3s', mb: 2, background: '#FFF', minWidth: 366 }}>
      <Stack gap={2} direction={'row'} alignItems={'center'} justifyContent={'space-between'}
             sx={{background: 'linear-gradient(137deg, rgba(247, 231, 186, 1) 0%, rgb(231 253 255) 70%)'}} p={'8px 12px'}>
        <Typography flex={1} variant={'h5'} fontWeight={500} noWrap>
          Reassigned by CSR
        </Typography>

        <Typography variant={'caption'} align={'right'}>
          {moment(item.createdAt).format('L H:mm')}
        </Typography>

        {onHide && <ButtonBase onClick={onHide}>
          <XIcon size={16} color={'#1c434f'} weight={'bold'} />
        </ButtonBase>}
      </Stack>

      <Typography flex={1} p={1} variant={'body2'}>
        Appointment scheduled for: <b>{moment(details.startTime).format('L H:mm')}</b> was reassigned to another agent.
      </Typography>

      <Box>
        <ButtonBase onClick={() => window.open(`/${'client'}/${details.invitee?.clientId}`, '_blank')}
                    sx={{
                      padding: '4px 8px',
                      borderRadius: '8px'
                    }}
        >
          <UserAvatar size={32}
                      fontSize={13}
                      showEmail
                      email={details.invitee?.email}
                      name={details.invitee?.name} />
        </ButtonBase>
      </Box>

      <Stack p={1} justifyContent={'flex-end'} gap={1} direction={'row'}>
        <LoadingButton sx={{width: 100}} size={'small'} variant={'contained'} onClick={complete}>
          Close
        </LoadingButton>
      </Stack>
    </Portal>
  );
};
